<template>
  <div>
    <PCNavbar selectIndex="1" />
    <MobileNavBar :currentActive="0" />
    <CarouselHome />

    <div class="bottom_circle"></div>

    <div class="core_options">
      <div class="core_items is_active">
        香港萬知集團
      </div>
    </div>
    <div class="intro-wrapper">
      <div class="container">
        <div class="intro-card">
          <div class="intro-decoration"></div>
          <div class="intro-content">
            <p>
              香港萬知國際集團是立足亞太、輻射全球的全鏈條國際化學術出版產業集團，構建起技術、出版、內容、資本一體化協同的運營模式。集團擁有自主研發的學術AI數字化技術底座，打造智能投審稿、客戶管理兩大專用系統，並研發學術垂直AI大模型，可完成英文潤色、合規校驗、評審輔助、數據復盤等智能化工作，在賦能自身業務的同時，也能為海內外高校、科研院所提供學術數字化改造方案。
            </p>
            <p>
              出版板塊採用香港、新加坡雙總部佈局，全資運營兩地ISE出版社，執行統一的質控、發行與風控標準，依托兩地國際化優勢，與各大高校、科研機構及海外學術組織深度合作，專注高端英文学術成果的合規出版與全球傳播。集團搭建起期刊、專著、譯著三位一體的內容矩陣，目前運營多學科開源英文学術期刊，積極衝刺國際主流索引收錄，為科研團隊提供學術專著、科研彙編、涉外教材定制出版服務，並開展中外雙向譯著業務，助力科研成果出海，引進優質學術資源。
            </p>
            <p>
              除此之外，集團深耕學術出版垂直領域資本服務，提供出版社並購託管、新刊培育、版權估值、專項投融資等服務，以產業資本推動主業持續發展。憑藉自主技術、雙出版平台、精品內容與產融結合四大核心優勢，集團形成堅實競爭壁壘，成為新一代綜合型國際化學術出版企業。
            </p>
          </div>
        </div>
      </div>
    </div>
    <section class="section products-section" id="products">
      <div class="container">
        <div class="section-head center">
          <span class="section-label">Core Products</span>
          <h2 class="section-title">期刊·著作·譯著 三位一體</h2>
          <p class="section-subtitle">
            以精品化學術內容為核心，構建多維度學術出版產品矩陣
          </p>
        </div>

        <el-tabs v-model="activeProduct" class="modern-tabs">
          <el-tab-pane name="0">
            <span slot="label">國際譯著</span>
            <div class="product-card-wrapper">
              <el-card shadow="hover" class="product-card">
                <el-row :gutter="40" align="middle" type="flex">
                  <el-col :lg="14" :xs="24" class="text-col">
                    <div class="content-inner">
                      <div class="num-bg">01</div>
                      <h3>中外雙向學術譯著出版</h3>
                      <div class="desc-text">
                        <p>
                          對內推動國內前沿科研成果英譯出海，對外引進海外權威學術經典實現本土化精編，雙向打通中外學術資源交流通道。
                        </p>
                      </div>
                      <div class="tags-wrap">
                        <el-tag
                          class="custom-tag"
                          v-for="tag in transTags"
                          :key="tag"
                          >{{ tag }}</el-tag
                        >
                      </div>
                    </div>
                  </el-col>
                  <el-col :lg="10" :xs="24" class="visual-col">
                    <div class="visual-box trans-visual">
                      <img
                        src="../assets/img/home/gjzz.png"
                        alt="Global Translation"
                        class="product-img"
                      />
                    </div>
                  </el-col>
                </el-row>
              </el-card>
            </div>
          </el-tab-pane>
          <el-tab-pane name="1">
            <span slot="label"><i class="el-icon-book"></i> 學術著作</span>
            <div class="product-card-wrapper">
              <el-card shadow="hover" class="product-card">
                <el-row :gutter="40" align="middle" type="flex">
                  <el-col :lg="14" :xs="24" class="text-col">
                    <div class="content-inner">
                      <div class="num-bg">02</div>
                      <h3>高端學術著作出版服務</h3>
                      <div class="desc-text">
                        <p>
                          面向高校學者及科研團隊，提供學術專著、科研成果文集、專業學科教材等高端出版服務，助力前沿科研成果的系統性沉澱與國際化發表。
                        </p>
                      </div>
                      <div class="tags-wrap">
                        <el-tag
                          class="custom-tag"
                          v-for="tag in bookTags"
                          :key="tag"
                          >{{ tag }}</el-tag
                        >
                      </div>
                    </div>
                  </el-col>
                  <el-col :lg="10" :xs="24" class="visual-col">
                    <div class="visual-box book-visual">
                      <img
                        src="../assets/img/home/xszz.png"
                        alt="Academic Books"
                        class="product-img"
                      />
                    </div>
                  </el-col>
                </el-row>
              </el-card>
            </div>
          </el-tab-pane>
          <el-tab-pane name="2">
            <span slot="label">學術期刊</span>
            <div class="product-card-wrapper">
              <el-card shadow="hover" class="product-card">
                <el-row :gutter="40" align="middle" type="flex">
                  <el-col :lg="14" :xs="24" class="text-col">
                    <div class="content-inner">
                      <div class="num-bg">03</div>
                      <h3>多學科英文学術期刊矩陣</h3>
                      <div class="desc-text">
                        <p>
                          現階段自主運營
                          <strong>14–16 本</strong>
                          多學科英文学術期刊，嚴格遵循國際學術標準進行專業培育運營，以衝刺
                          <strong>SCI 收錄</strong>為近期核心目標。
                        </p>
                        <p>
                          中長期透過自主創辦與優質期刊併購雙軌並進，將刊群總量擴充至
                          <strong>50 本</strong>
                          ，打造規模化、多學科、高影響力的國際期刊矩陣。
                        </p>
                      </div>
                      <div class="tags-wrap">
                        <el-tag
                          class="custom-tag"
                          v-for="tag in journalTags"
                          :key="tag"
                          >{{ tag }}</el-tag
                        >
                      </div>
                    </div>
                  </el-col>
                  <el-col :lg="10" :xs="24" class="visual-col">
                    <div class="visual-box journal-visual">
                      <img
                        src="../assets/img/home/xsqk.png"
                        alt="Academic Journals"
                        class="product-img"
                      />
                    </div>
                  </el-col>
                </el-row>
              </el-card>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </section>

    <CoreCompetence />
    <NewsInfomation />
    <CallMe />
    <MobileCallme />
  </div>
</template>

<script>
import PCNavbar from "@/components/navbar/index";
import MobileNavBar from "@/components/navbar/MobileNavBar.vue";
import CarouselHome from "@/components/carousel_home/index";
import CoreCompetence from "@/components/core_competence/index";
import NewsInfomation from "@/components/news_infomation/index";
import CallMe from "@/components/callme/index";
import MobileCallme from "@/components/callme/MobileCallme.vue";

export default {
  components: {
    PCNavbar,
    MobileNavBar,
    CarouselHome,
    CoreCompetence,
    NewsInfomation,
    CallMe,
    MobileCallme
  },
  data() {
    return {
      activeProduct: "0",
      journalTags: ["14–16 本在運營刊", "目標 50 本", "沖刺 SCI", "多學科覆蓋"],
      bookTags: ["學術專著", "科研成果文集", "專業學科教材", "全球發行"],
      transTags: ["中→英 出海", "外→中 引進", "雙向交流", "專業譯者團隊"]
    };
  }
};
</script>

<style lang="scss" scoped>
$primary-color: #0649b8;
$secondary-color: #03d2c5;
$accent-color: #c9a84c;
$text-main: #333;
$text-secondary: #555;
$bg-light: #f9fafb;

.section {
  padding: 80px 0;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-head {
  margin-bottom: 60px;
  text-align: center;
}

.section-label {
  display: block;
  font-size: 14px;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: $accent-color;
  margin-bottom: 12px;
  font-weight: 600;
}

.section-title {
  font-size: 36px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 16px;
  line-height: 1.2;
}

.section-subtitle {
  font-size: 16px;
  color: #666;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

/* 顶部装饰圆圈 */
.bottom_circle {
  width: 100%;
  height: 120px;
  background-image: url(../assets/img/smalldot.png),
    url(../assets/img/smalldot1.png);
  background-position: 0 0, 110% 150%;
  background-repeat: no-repeat;
  background-size: 400px;
}

/* 集团标题按钮 */
.core_options {
  display: flex;
  justify-content: center;
  margin: 40px 0 20px;
  .core_items {
    padding: 0 40px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    font-size: 24px;
    font-weight: bold;
    cursor: default;
  }
  .is_active {
    color: #fff;
    background: linear-gradient(
      134deg,
      $primary-color 1%,
      #0a7fd7 41%,
      $secondary-color 99%
    );
    box-shadow: 0 4px 12px rgba(6, 73, 184, 0.3);
  }
}

/* --- 优化后的集团介绍部分样式 --- */
.intro-wrapper {
  padding: 0 20px;
  margin-bottom: 60px;
}

.intro-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  padding: 50px 60px;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.03);

  /* 左侧装饰条 */
  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 6px;
    background: linear-gradient(180deg, $primary-color, $secondary-color);
  }
}

.intro-content {
  p {
    font-size: 16px;
    line-height: 2;
    color: $text-secondary;
    text-align: justify;
    margin-bottom: 20px;
    text-indent: 2em; /* 首行缩进 */

    &:last-child {
      margin-bottom: 0;
    }
  }
}

/* 移动端适配 - 集团介绍 */
@media screen and (max-width: 768px) {
  .intro-wrapper {
    padding: 0 15px;
    margin-bottom: 40px;
  }

  .intro-card {
    padding: 30px 20px;
    border-radius: 12px;

    &::before {
      width: 4px;
    }
  }

  .intro-content p {
    font-size: 14px;
    line-height: 1.8;
    margin-bottom: 15px;
  }
}

/* --- 核心产品部分优化样式 --- */
.products-section {
  background: $bg-light;
  position: relative;
  overflow: hidden;
}

/* 现代 Tabs 样式覆盖 */
.modern-tabs {
  ::v-deep .el-tabs__header {
    margin-bottom: 40px;
    border-bottom: none;
    display: flex;
    justify-content: center;
  }

  ::v-deep .el-tabs__nav-wrap::after {
    display: none; /* 移除默认底边线 */
  }

  ::v-deep .el-tabs__item {
    font-size: 18px;
    font-weight: 500;
    color: #606266;
    padding: 0 30px;
    height: 50px;
    line-height: 50px;
    transition: all 0.3s;
    border: 1px solid transparent;
    border-radius: 25px;
    margin: 0 10px;

    i {
      margin-right: 8px;
      font-size: 20px;
    }

    &:hover {
      color: $primary-color;
    }
  }

  ::v-deep .el-tabs__item.is-active {
    color: #fff;
    background: linear-gradient(90deg, $primary-color, $secondary-color);
    box-shadow: 0 4px 10px rgba(6, 73, 184, 0.2);
  }

  ::v-deep .el-tabs__active-bar {
    display: none; /* 移除默认滑动条 */
  }
}

/* 产品卡片 */
.product-card-wrapper {
  animation: fadeIn 0.5s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.product-card {
  border: none;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.06);
  padding: 10px;
  overflow: visible;

  ::v-deep .el-card__body {
    padding: 40px;
    @media screen and (max-width: 768px) {
      padding: 20px;
    }
  }
}

/* 内容布局 */
.text-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.content-inner {
  position: relative;
  z-index: 1;
}

.num-bg {
  position: absolute;
  top: -30px;
  left: -10px;
  font-size: 80px;
  font-weight: 900;
  color: rgba(201, 168, 76, 0.1);
  line-height: 1;
  z-index: -1;
  user-select: none;
}

h3 {
  font-size: 24px;
  color: #1a1a1a;
  margin-bottom: 20px;
  font-weight: 700;
  position: relative;
  display: inline-block;

  &::after {
    content: "";
    position: absolute;
    bottom: -8px;
    left: 0;
    width: 40px;
    height: 3px;
    background: $accent-color;
  }
}

.desc-text {
  color: #555;
  font-size: 16px;
  line-height: 1.8;
  margin-bottom: 24px;

  p {
    margin-bottom: 12px;
  }

  strong {
    color: $primary-color;
    font-weight: 600;
  }
}

/* 标签样式 */
.tags-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.custom-tag {
  border: none;
  background: rgba(6, 73, 184, 0.08);
  color: $primary-color;
  border-radius: 4px;
  padding: 2px 12px;
  font-size: 13px;

  &:hover {
    background: rgba(6, 73, 184, 0.15);
  }
}

/* 视觉盒子容器 */
.visual-col {
  display: flex;
  justify-content: center;
  align-items: center;
}

.visual-box {
  width: 100%;
  max-width: 380px; /* 稍微加大，更显大气 */
  aspect-ratio: 4/3; /* 保持舒适的宽高比 */
  border-radius: 12px; /* 圆角稍微减小，更显专业严谨 */
  position: relative;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1); /* 更平滑的动画曲线 */
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08); /* 柔和的阴影 */
  background: #f5f7fa; /* 加载前的底色 */

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);
  }
}

/* 图片样式 */
.product-img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 关键：确保图片填满且不变形 */
  transition: transform 0.6s ease;
  display: block;
}

/* 悬停时图片轻微放大，增加高级感 */
.visual-box:hover .product-img {
  transform: scale(1.08);
}

/* 各个板块的微弱色调区分（作为图片加载失败时的兜底，或透过图片隐约可见） */
.journal-visual {
  /* 暖色调：象征人文与历史 */
  background: linear-gradient(135deg, #fff9f0 0%, #fff 100%);
}

.book-visual {
  /* 冷色调：象征科技与理性 */
  background: linear-gradient(135deg, #f0f7ff 0%, #fff 100%);
}

.trans-visual {
  /* 青绿色调：象征交流与生机 */
  background: linear-gradient(135deg, #f0fff9 0%, #fff 100%);
}

/* 移动端适配 - 产品部分 */
@media screen and (max-width: 768px) {
  .section {
    padding: 40px 0;
  }

  .section-title {
    font-size: 24px;
  }

  .modern-tabs {
    ::v-deep .el-tabs__item {
      padding: 0 15px;
      font-size: 14px;
      margin: 0 5px;

      i {
        display: none; /* 移动端隐藏图标以节省空间 */
      }
    }
  }

  .product-card {
    ::v-deep .el-card__body {
      padding: 20px 15px;
    }
  }

  .num-bg {
    font-size: 50px;
    top: -15px;
  }

  h3 {
    font-size: 20px;
  }

  .desc-text {
    font-size: 14px;
  }

  .visual-box {
    max-width: 100%;
    margin-top: 20px;
    aspect-ratio: 16/9; /* 移动端更宽扁一点 */
  }

  /* 移动端调整 Flex 顺序，让图片在文字下方 */
  .el-row {
    flex-direction: column;
  }

  .text-col,
  .visual-col {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue